import React from 'react';
import DefaultFilter from './DefaultFilter';

export default function NumberFilter(props) {
    return <DefaultFilter column={props.column} operation="=" type="number" />;
}
